import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step13_Residencia: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.residence) newErrors.residence = 'Tipo de residência é obrigatório';
    if (!data.residenceTime) newErrors.residenceTime = 'Tempo de moradia é obrigatório';
    if (!data.residenceProof) newErrors.residenceProof = 'Comprovante de residência é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ 
      residence: data.residence as 'own' | 'rented' | 'family', 
      residenceTime: data.residenceTime,
      residenceProof: data.residenceProof as 'own-name' | 'spouse-name' | 'family-name' | 'no-proof'
    });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="Qual o tipo de sua residência?">
      <div className="space-y-6">
        <div>
          <ChoiceButtons
            options={[
              { label: 'Própria', value: 'Própria' },
              { label: 'Alugada', value: 'Alugada' },
            ]}
            selected={data.residence || ''}
            onSelect={(value) => handleFieldChange('residence', value)}
          />
          {errors.residence && (
            <p className="text-red-600 text-sm mt-2">{errors.residence}</p>
          )}
        </div>

        <FormFieldGroup
          label="Há quanto tempo mora neste local?"
          required
          error={errors.residenceTime}
        >
         <ChoiceButtons
            options={[
              { label: 'Menos de 3 meses', value: 'Menos de 3 meses' },
              { label: 'Menos de 6 meses', value: 'Menos de 6 meses' },
              { label: 'Menos de 1 ano', value: 'Menos de 1 ano' },
              { label: 'Entre 1 ano e 2 anos', value: 'Entre 1 ano e 2 anos' },
              { label: 'Entre 2 anos e 5 anos', value: 'Entre 2 anos e 5 anos' },
              { label: 'Mais de 5 anos', value: 'Mais de 5 anos' },
              { label: 'Mais de 10 anos', value: 'Mais de 10 anos' },
            ]}
            selected={data.residenceTime || ''}
            onSelect={(value) => handleFieldChange('residenceTime', value)}
          />
        </FormFieldGroup>

        <FormFieldGroup
          label="Você possui comprovante de residência recente (últimos 90 dias), em seu nome? Os comprovantes aceitos são: conta de água, luz, gás, telefone, internet, fatura de cartão ou carnê de IPTU."
          required
          error={errors.residenceProof}
        >
          <ChoiceButtons
            options={[
              { label: 'Sim, em meu nome', value: 'own-name' },
              { label: 'Sim, no nome do cônjuge', value: 'spouse-name' },
              { label: 'Sim, no nome de familiar (pai/mãe)', value: 'family-name' },
              { label: 'Não possuo comprovante no momento', value: 'no-proof' },
            ]}
            selected={data.residenceProof || ''}
            onSelect={(value) => handleFieldChange('residenceProof', value)}
          />
        </FormFieldGroup>
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step13_Residencia;
